module.exports = __webpack_public_path__ + "static/media/loading2.31dd2fb3.gif";